import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

export const communicate: RouteRecordRaw = {
  name: 'admin.communicate',
  path: '/communicate',
  component: () => import('pages/Communicate.vue'),
  meta: {
    roles: [
      Roles.CenterAdmin,
      Roles.OfficeStaff,
      Roles.OrgAdmin,
      Roles.RoomStaff,
      Roles.SuperAdmin,
    ],

    supportedPlatforms: ['desktop'],
    excludeEnv: [],
  },
}
